import { postObject } from '../ChoiceApi'

export const immunization = 
{
    async sendToRegistry(request: ISendToRegistryRequest): Promise<ISendToRegistryResp|undefined>
    {
        return postObject<ISendToRegistryResp>("api/Chart/Immunization/SendToRegistry", request);
    }
}

export interface ISendToRegistryRequest
{
    historical_ind: "Y" | "N",
    items: IImmunizationItemModel[]
}
export interface IImmunizationItemModel
{
    immunization_id: number;
    resend_id?: number, 
    diagnosis_id?: number
}
export interface ISendToRegistryResp
{
    sentAsBatch: boolean, 
    transactionId?: number
}